import React from 'react';
import Image from '../Image';
import Radio from '../../Radio';
import SpinnerSVG from '../../../../svgs/spinner.svg';
import {
    formatPrice,
    filterGEOProductSKUs,
    ga4TrackingEcommerce
} from '../../../tools/utilities';

export default class ProductTypeResult extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            skus: props.item.skus ? props.item.skus : [],
            activeSkus: props.item.skus ? props.item.skus : [],
            selectedSku: props.item.skus ? props.item.skus[0] : props.item,
            tags: [
                {
                    key: 'outofstock',
                    value: 'Out of stock',
                },
                {
                    key: 'on-sale',
                    value: 'Sale',
                },
                {
                    key: 'signed',
                    value: 'Signed',
                },
                {
                    key: 'exclusive',
                    value: 'Exclusive',
                },
                {
                    key: 'popular',
                    value: 'Popular',
                },
                {
                    key: 'personalised',
                    value: 'Personalised',
                },
            ],
            descriptionActive: false,
            activeTag: '',
            country: props.country ? props.country : 'GB',
            currency: props.currency ? props.currency : 'GBP',
            locale:
                'locale' in Intl.NumberFormat().resolvedOptions()
                    ? Intl.NumberFormat().resolvedOptions().locale
                    : 'en-GB',
            userGeoData: props.userGeoData
                ? props.userGeoData
                : {
                      country: 'GB',
                      currency: 'GBP',
                      locale: 'en-GB',
                  },
            dispatchEvent: props.dispatchEvent ? props.dispatchEvent : false,
        };
        this.addToCartRef = React.createRef();
    }

    componentDidMount() {
        this.setupSkus();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { dispatchEvent } = this.state;

        if (this.props.item !== null && prevProps !== this.props) {
            this.setupSkus();
        }

        if (this.addToCartRef.current !== null) {
            if (dispatchEvent) {
                document.dispatchEvent(new Event('PelcroProductsLoaded'));
                this.addToCartRef.current.classList.add('pelcro-listener-added');
            } else {
                this.addToCartRef.current.classList.add('pelcro-listener-added');
            }
        }
    }

    setupSkus = () => {
        this.setSkus();
        this.setActiveTag();
        this.setState({ loading: false });
    };

    setActiveTag = () => {
        const { item } = this.props;
        const { activeSkus, tags } = this.state;
        let activeTag = '';

        if (!item.inStock || activeSkus.length <= 0) {
            activeTag = 'outofstock';
        } else if (!item.onSale) {
            activeTag = 'on-sale';
        } else {
            for (let i = 0; i < item.tags.length; i++) {
                const activeTagItem = tags.find(tag => tag.key == item.tags[i].toLowerCase());

                if (activeTagItem) {
                    activeTag = activeTagItem.key;
                    break;
                }
            }
        }

        this.setState({ activeTag });
    };

    setSkus = () => {
        const { item } = this.props;
        const { country, currency } = this.state;
        const skus = filterGEOProductSKUs(item.skus, currency, country);
        const activeSkus = skus.filter(sku => sku.inStock);

        let selectedSku = item;
        if (activeSkus.length > 0) {
            const firstKey = Object.keys(activeSkus)[0];
            selectedSku = activeSkus[firstKey];
        }

        this.setState({ skus, activeSkus, selectedSku });
    };

    showTag() {
        const { item, hideContent } = this.props;
        const { tags, activeTag } = this.state;
        const activeTagItem = tags.find(tag => tag.key == activeTag);
        const hasImage = !hideContent && item.image ? '' : 'product-card__tag--relative';

        if (activeTagItem) {
            return (
                <span className={`product-card__tag product-card__tag--${activeTagItem.key} ${hasImage} proxima`}>
                    {activeTagItem.value}
                </span>
            );
        }

        return <></>;
    }

    showPrice() {
        const { selectedSku, locale } = this.state;

        if (selectedSku.price !== selectedSku.regularPrice) {
            return (
                <span className="product-card__pricing proxima">
                    <span className="amount amount--sale-price">
                        {formatPrice(selectedSku.price, selectedSku.currency, locale)}
                    </span>
                    <span className="amount amount--old-price">
                        {formatPrice(selectedSku.regularPrice, selectedSku.currency, locale)}
                    </span>
                </span>
            );
        }

        return (
            <span className="product-card__pricing proxima">
                <span className="amount">{formatPrice(selectedSku.price, selectedSku.currency, locale)}</span>
            </span>
        );
    }

    showSkus() {
        const { item } = this.props;
        const { skus, selectedSku } = this.state;

        if (skus && skus.length > 1) {
            return (
                <div className="product-card__skus radio-input-group">
                    {skus.map((sku, i) => {
                        let label = sku.description !== '' ? sku.description : sku.name;
                        if (label.toLowerCase().includes('print')) {
                            label = 'Print';
                        } else if (label.toLowerCase().includes('digital')) {
                            label = 'Digital';
                        }
                        return (
                            <div
                                className={
                                    'radio-input-group__radio' +
                                    (selectedSku.id === sku.id ? ' radio-input-group__radio--active' : '')
                                }
                                key={i}>
                                <Radio
                                    name={`product-card-radio-${item.id}`}
                                    id={`product-card-radio-${item.id}-${sku.id}`}
                                    value={sku.id}
                                    label={label}
                                    checked={selectedSku.id === sku.id}
                                    onChange={this.handleSkuChange}
                                    disabled={!sku.inStock}
                                />
                            </div>
                        );
                    })}
                </div>
            );
        }

        return <></>;
    }

    handleSkuChange = e => {
        if (e.target !== null) {
            const { skus } = this.state;
            const skuItem = skus.find(sku => sku.id == e.target.value);
            if (skuItem) {
                this.setState({
                    selectedSku: skuItem,
                });
                ga4TrackingEcommerce('view_item', [skuItem]);
            }
        }
    };

    handleAddToCartUrl = () => {
        const { selectedSku } = this.state;
        const url = new URL(window.location);
        url.searchParams.set('view', 'cart');
        url.searchParams.set('sku_id', `${selectedSku.id}`);

        return url.href;
    };

    toggleDescription = () => {
        const { descriptionActive } = this.state;
        this.setState({
            descriptionActive: descriptionActive ? false : true,
        });
    };

    render = () => {
        const { item, modifier, variant } = this.props;
        const { loading, skus, activeSkus, selectedSku, descriptionActive } = this.state;
        const analytics = this.props.analytics || '';
        const hideContent = this.props.hideContent || false;
        const displayBuyLink = this.props.displayBuyLink || false;
        const productTitle = item.caption !== '' ? item.caption : item.name;
        const modifierClass = modifier && modifier !== '' ? ` product-card--${modifier}` : '';
        const descriptionClass = descriptionActive ? ` product-card__description--active` : '';

        return (
            skus.length > 0 && (
                <article className={`product-card${modifierClass}${variant ? ' product-card--variant' : ''}`}>
                    <div className="product-card__wrapper">
                        <div className="product-card__content">
                            {!hideContent && this.showTag()}
                            {!hideContent && item.image && (
                                <div className="product-card__image">
                                    <Image uri={item.image} />
                                </div>
                            )}
                            {!hideContent && <h3 className="product-card__title sanomat">{productTitle}</h3>}
                            {!hideContent && item.description !== '' && (
                                <div className={`product-card__description ${descriptionClass}`}>
                                    {descriptionActive
                                        ? item.description
                                        : item.description
                                              .split(' ')
                                              .splice(0, 14)
                                              .join(' ')}
                                    {!descriptionActive && item.description.split(' ').length > 14 && (
                                        <button
                                            className="product-card__description-toggle"
                                            onClick={() => this.toggleDescription()}>
                                            Read more
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="product-card__actions">
                            {loading && (
                                <img
                                    src={SpinnerSVG}
                                    alt="loading"
                                    className="loading"
                                    style={{
                                        width: '20px',
                                        height: '20px',
                                        marginTop: '3rem',
                                        marginBottom: '3rem',
                                    }}
                                />
                            )}
                            {!loading && item.inStock && activeSkus.length > 0 && this.showSkus()}
                            {!loading && displayBuyLink
                                ? item.inStock &&
                                  activeSkus.length > 0 && (
                                      <a
                                          className={`product-card__purchase button button--alt ${analytics}`}
                                          href={this.handleAddToCartUrl()}>
                                          Add to cart
                                          {this.showPrice()}
                                      </a>
                                  )
                                : !loading &&
                                  item.inStock &&
                                  activeSkus.length > 0 && (
                                      <button
                                          ref={this.addToCartRef}
                                          className={`pelcro-add-to-cart-button product-card__purchase button button--alt ${analytics}`}
                                          data-sku-id={selectedSku.id}>
                                          Add to cart
                                          {this.showPrice()}
                                      </button>
                                  )}
                        </div>
                    </div>
                </article>
            )
        );
    };
}
